import { render, staticRenderFns } from "./ZinnesInformations.vue?vue&type=template&id=8bf829f6&scoped=true"
import script from "./ZinnesInformations.vue?vue&type=script&lang=js"
export * from "./ZinnesInformations.vue?vue&type=script&lang=js"
import style0 from "./ZinnesInformations.vue?vue&type=style&index=0&id=8bf829f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf829f6",
  null
  
)

export default component.exports